import {
  AutomationsPresentationV1Edge,
  AutomationsPresentationV1Node
} from 'Automations/automationEditor/types'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import { getUpstreamNodesWithOutputs } from '../getUpstreamNodesWithOutputs'
import { getValidVariants } from '../getValidVariants'
import { reviewTypeTargetDefinition } from '../../definitions/review/review.types'
import { actionTypeTargetDefinition } from '../../definitions/action/action.types'

const placeholderVariantMap: Partial<Record<NodeType, NodeType[]>> = {
  REVIEW_PLACEHOLDER: Object.values(reviewTypeTargetDefinition),
  ACTION_PLACEHOLDER: Object.values(actionTypeTargetDefinition)
}

/**
 * Given a set of nodes and edges, auto-selects the variant for any
 * placeholder node that has exactly one valid variant based on upstream
 * semantic types.
 */
export const applyAutoSelectVariants = ({
  nodes,
  edges,
  definitions
}: {
  nodes: AutomationsPresentationV1Node[]
  edges: AutomationsPresentationV1Edge[]
  definitions: ResolvedNodeDefinitions
}): AutomationsPresentationV1Node[] => {
  return nodes.reduce<AutomationsPresentationV1Node[]>((acc, node) => {
    const variantNodeTypes = placeholderVariantMap[node.type as NodeType]
    if (!variantNodeTypes) return [...acc, node]

    const upstreamNodes = getUpstreamNodesWithOutputs({
      nodes,
      edges,
      targetNodeId: node.id,
      definitions
    })

    const validVariants = getValidVariants({
      upstreamNodes,
      variantNodeTypes,
      definitions
    })

    if (validVariants.length !== 1) return [...acc, node]

    const targetType = validVariants[0]
    return [
      ...acc,
      {
        ...node,
        type: targetType,
        data: {
          ...definitions[targetType].defaultConfig,
          name: (node.data as { name?: string }).name ?? ''
        }
      }
    ]
  }, [])
}
